import React, { Component, Fragment } from 'react';
import './DownloadsProgramLanguages.module.scss';

import PageTitle from '../../components/UI/PageTitle/PageTitle'
import Button from '../../components/UI/Button/Button'
import ButtonFullWidth from '../../components/UI/ButtonFullWidth/ButtonFullWidth';
import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import BackgroundPolygons from 'components/UI/BackgroundPolygons/BackgroundPolygons';

class DownloadsProgramLanguages extends Component {

    //scroll to top
    componentDidUpdate() {
        window.scrollTo(0,0);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <Fragment>
                <TopNavigation/>
                <SideNavigation/>
                <PageWrapper>
                    <div styleName='main'>
                    <BackgroundPolygons></BackgroundPolygons>
                        <div styleName='maxwidth'>
                            <PageTitle title='Downloads' subtitle='Aansturing GoTo'/>
                            <div styleName='downloadblock'>
                                <div styleName='polygon1'></div>
                                <div styleName='polygon2'></div>
                                <p>Kies welke programmeer taal je wil downloaden.</p>
                                <div styleName='download-element'>
                                    <img src='/images/svg/scratch.svg'></img>
                                    <h3>Scratch</h3>
                                    <p>Scratch is een programmeeromgeving die gebruik maakt van visuele scripting.       

                                    </p>
                                    <ButtonFullWidth text='Scratch' link='/downloadssnap'/>
                                </div>
                                <div styleName='download-element'>
                                    <img src='/images/svg/processing.svg'></img>
                                    <h3>Processing</h3>
                                    <p>Processing wordt gebruikt door studenten, kunstenaars, designers, onderzoekers en hobbyisten 
                                    om te leren programmeren.       

                                    </p>
                                    <ButtonFullWidth text='Processing' link='/downloadsprocessing'/>
                                </div>
                                <div styleName='download-element'>
                                    <img src='/images/svg/python.svg'></img>
                                    <h3>Python</h3>
                                    <p>Python is ontwikkeld op basis van BASIC met als doel zo snel en efficiënt mogelijk programmeren. 


                                    </p>
                                    <ButtonFullWidth text='Python' link='downloadspython'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageWrapper>
            </Fragment>
        );      
    }
}

export default DownloadsProgramLanguages;


// WEBPACK FOOTER //
// ./resources/assets/screens/DownloadsProgramLanguages/DownloadsProgramLanguages.jsx